import React, { useState } from 'react'
import { Button, Radio } from 'antd'
import { Input, Textarea, useTraversal } from '@guillotinaweb/react-gmi'

import { I18NField } from './i18nfield'
import { setLangs } from '../consts'

const field = 'api.behaviors.content_review.IContenidosRevisadosBehavior'

export function ContentReviewTab() {
  const Ctx = useTraversal()
  const [review, setReview] = useState(
    Ctx.state.context[field]?.contendidos_revisados ||
      setLangs({
        date: new Date().toISOString(),
        author: '',
        description: '',
        reviewed: false,
      })
  )
  // const superAdmin = Ctx.state.permissions['vinissimus.Superuser']
  const superAdmin = true
  const [saving, setSaving] = useState(false)

  const h1 =
    typeof Ctx.state.context.title === 'string'
      ? Ctx.state.context.title
      : Ctx.state.context['@name']

  async function save() {
    setSaving(true)
    const flashOk = ['Content review fields saved', 'success']
    const flashKo = ['Error saving the content review fields', 'danger']
    const { status } = await Ctx.client.patch(Ctx.path, {
      [field]: { contendidos_revisados: review },
    })
    Ctx.flash(...(status === 204 ? flashOk : flashKo))
    setSaving(false)
  }

  return (
    <>
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          padding: 10,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1 className="title is-size-4 is-primary">{h1}</h1>
        <Button type="primary" disabled={saving || !superAdmin} onClick={save}>
          {saving ? 'Saving...' : 'Save review'}
        </Button>
      </div>
      <I18NField Widget={() => null}>
        {(lang) => {
          const langReview = review[lang] || {
            date: new Date().toISOString(),
            author: '',
            description: '',
          }

          return (
            <div style={{ marginTop: 20 }}>
              <Radio.Group
                onChange={(e) =>
                  setReview((o) => ({
                    ...o,
                    [lang]: {
                      ...langReview,
                      reviewed: e.target.value,
                      date: new Date().toISOString(),
                      author: localStorage.getItem('email'),
                    },
                  }))
                }
                disabled={!superAdmin}
                value={langReview.reviewed ?? false}
                optionType="button"
              >
                <Radio value={true}>Reviewed</Radio>
                <Radio value={false}>No reviewed</Radio>
              </Radio.Group>
              <div style={{ marginTop: 15 }} />
              <Textarea
                value={langReview.description}
                placeholder="Description"
                disabled={!superAdmin}
                id="description"
                onChange={(description) => {
                  setReview((o) => ({
                    ...o,
                    [lang]: {
                      ...langReview,
                      description,
                      date: new Date().toISOString(),
                      author: localStorage.getItem('email'),
                    },
                  }))
                }}
              />
              <Input value={langReview.author} placeholder="Author" disabled />
              <Input
                value={langReview.date}
                placeholder="Date"
                disabled
                id="date"
              />
            </div>
          )
        }}
      </I18NField>
    </>
  )
}
